import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";

const SectionObserver = ({ id, children }) => {
  // rootMargin so setzen, dass der Trigger in der Mitte des Bildschirms liegt
  const { ref, inView } = useInView({
    threshold: 0.05,
    rootMargin: "-40% 0px -40% 0px"
  });

  useEffect(() => {
    if (inView) {
      window.dispatchEvent(new CustomEvent("sectionVisible", { detail: id }));
    }
  }, [inView, id]);

  return <div ref={ref}>{children}</div>;
};

export default SectionObserver;
